export default __webpack_public_path__ + "static/Awaken_Small-f6a068986a254c7e1bae3dbef3a2bb77.jpg";